export default "__VITE_ASSET__tPqF$FIX__"